import {
  type ApiResponse
} from '../../api-client';

import {
  apiRequest
} from './client';

import type {
  ProfitReportType,
  ProfitReportData
} from './types/profit-report.types';

export interface GetProfitReportParams {
  dateFrom?: Date
  dateTo?: Date
  /** Defaults to 'ALL' server-side */
  type?: ProfitReportType
  limit?: number
  offset?: number
}

/** Admin only. Enquiry/package/donation/subscription revenue netted against referral rewards and (enquiries only) fulfiller payouts. */
export async function getProfitReport(
  params: GetProfitReportParams = {},
  token: string
): Promise<ApiResponse<ProfitReportData>> {

  const query = new URLSearchParams();

  if (params.dateFrom !== undefined) {

    query.set('dateFrom', params.dateFrom.toISOString());
  }

  if (params.dateTo !== undefined) {

    query.set('dateTo', params.dateTo.toISOString());
  }

  if (params.type !== undefined) {

    query.set('type', params.type);
  }

  if (params.limit !== undefined) {

    query.set('limit', String(params.limit));
  }

  if (params.offset !== undefined) {

    query.set('offset', String(params.offset));
  }

  const qs = query.size > 0 ? `?${ query.toString() }` : '';
  return apiRequest<ApiResponse<ProfitReportData>>(`/reports/profit${ qs }`, undefined, token);
}
